"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTheme = exports.defaultScheme = void 0;
const create_breakpoints_1 = __importDefault(require("./create-breakpoints"));
const create_colors_1 = __importDefault(require("./create-colors"));
const create_shadow_1 = __importDefault(require("./create-shadow"));
const create_size_1 = __importDefault(require("./create-size"));
const create_spacing_1 = __importDefault(require("./create-spacing"));
const create_typography_1 = __importDefault(require("./create-typography"));
exports.defaultScheme = "light";
function createTheme(override = {}) {
    const { breakpoints, outline, schemes, shadow, spacing, typography, ...other } = override;
    return {
        ...(0, create_breakpoints_1.default)(breakpoints),
        ...(0, create_colors_1.default)(schemes),
        ...(0, create_shadow_1.default)(shadow, outline),
        ...(0, create_typography_1.default)(typography),
        size: (0, create_size_1.default)(),
        spacing: (0, create_spacing_1.default)(spacing),
        ...other,
    };
}
exports.createTheme = createTheme;
exports.default = createTheme;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY3JlYXRlLXRoZW1lLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vdGhlbWluZy9jcmVhdGUtdGhlbWUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUEsOEVBQTJGO0FBQzNGLG9FQUFvRTtBQUNwRSxvRUFBd0Y7QUFDeEYsZ0VBQWlEO0FBQ2pELHNFQUEyRTtBQUMzRSw0RUFBdUY7QUFnQjFFLFFBQUEsYUFBYSxHQUFHLE9BQU8sQ0FBQztBQUVyQyxTQUFnQixXQUFXLENBQUMsV0FBbUMsRUFBRTtJQUMvRCxNQUFNLEVBQUUsV0FBVyxFQUFFLE9BQU8sRUFBRSxPQUFPLEVBQUUsTUFBTSxFQUFFLE9BQU8sRUFBRSxVQUFVLEVBQUUsR0FBRyxLQUFLLEVBQUUsR0FBRyxRQUFRLENBQUM7SUFFMUYsT0FBTztRQUNMLEdBQUcsSUFBQSw0QkFBaUIsRUFBQyxXQUFXLENBQUM7UUFDakMsR0FBRyxJQUFBLHVCQUFZLEVBQUMsT0FBTyxDQUFDO1FBQ3hCLEdBQUcsSUFBQSx1QkFBWSxFQUFDLE1BQU0sRUFBRSxPQUFPLENBQUM7UUFDaEMsR0FBRyxJQUFBLDJCQUFnQixFQUFDLFVBQVUsQ0FBQztRQUMvQixJQUFJLEVBQUUsSUFBQSxxQkFBVSxHQUFFO1FBQ2xCLE9BQU8sRUFBRSxJQUFBLHdCQUFhLEVBQUMsT0FBTyxDQUFDO1FBQy9CLEdBQUcsS0FBSztLQUNULENBQUM7QUFDSixDQUFDO0FBWkQsa0NBWUM7QUFFRCxrQkFBZSxXQUFXLENBQUMifQ==